var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 29,
    viewBox: "0 0 40 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#147F26"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1507 25.8419L12.134 25.8586C11.909 25.3669 11.7673 24.8086 11.709 24.1919C11.7673 24.8002 11.9257 25.3502 12.1507 25.8419Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5009 18.6498C18.5963 18.6498 19.4842 17.7618 19.4842 16.6664C19.4842 15.5711 18.5963 14.6831 17.5009 14.6831C16.4055 14.6831 15.5176 15.5711 15.5176 16.6664C15.5176 17.7618 16.4055 18.6498 17.5009 18.6498Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.491 11.6665H16.5077C13.4743 11.6665 11.666 13.4748 11.666 16.5082V23.4915C11.666 24.3998 11.8243 25.1915 12.1327 25.8582C12.8493 27.4415 14.3827 28.3332 16.5077 28.3332H23.491C26.5244 28.3332 28.3327 26.5248 28.3327 23.4915V21.5832V16.5082C28.3327 13.4748 26.5244 11.6665 23.491 11.6665ZM26.9743 20.4165C26.3244 19.8582 25.2743 19.8582 24.6243 20.4165L21.1577 23.3915C20.5077 23.9498 19.4577 23.9498 18.8077 23.3915L18.5243 23.1582C17.9327 22.6415 16.991 22.5915 16.3243 23.0415L13.2077 25.1332C13.0243 24.6665 12.916 24.1248 12.916 23.4915V16.5082C12.916 14.1582 14.1577 12.9165 16.5077 12.9165H23.491C25.841 12.9165 27.0827 14.1582 27.0827 16.5082V20.5082L26.9743 20.4165Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/photo.8855e9b1355395b018b5d3c38f0072d5.svg";
export { ForwardRef as ReactComponent };